module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Carla Cassidy\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Carla Cassidy is a "), _c('I', [_vm._v("New York Times ")]), _vm._v("bestselling author who has written more than 125 novels for Harlequin Books.  She is listed on the Romance Writer's of America Honor Roll and has won numerous awards. Carla believes the only thing better than curling up with a good book to read is sitting down at the computer with a good story to write.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/lOAhmy/tc-custom/9781488033216.jpg?1704761434898",
      "alt": "This image is the cover for the book Desperate Strangers"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Desperate Strangers\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("His secrets might break her heart"), _c('br'), _c('br'), _vm._v("but hers could get them killed! ")]), _c('br'), _c('br'), _vm._v("Nick Simon is using his “fiancée,” Julie Peterson, as an alibi—and her amnesia means she doesn’t even know they only met at the scene of her accident. But when someone starts calling with threats of murder, Julie is drawn even closer to the only man who can protect her. Will she remember the deadly secret she carries before a murderer can strike again?\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0